/* GERADO por scripts/relayout/81-lp-v3.py (lp/v3/src/js): base + carro */
(() => {
/* ---------- Ajudantes de escopo: o build prefixa classes (z3-) e ids (zlp3-) no HTML e no CSS; aqui o JS faz o mesmo ---------- */
const R = document.getElementById('zlp3');
const D = JSON.parse(document.getElementById('zlp3-d').textContent);
const S = (sel) => sel.replace(/\.(-?[_a-zA-Z][\w-]*)/g, '.z3-$1').replace(/#([_a-zA-Z][\w-]*)/g, '#zlp3-$1');   // seletor
const $ = (sel, c = R) => c.querySelector(S(sel));
const $$ = (sel, c = R) => [...c.querySelectorAll(S(sel))];
const I = (id) => document.getElementById('zlp3-' + id);
const C = (n) => 'z3-' + n;                                                                                       // classe
const H = (html) => html                                                                                          // HTML montado no JS
  .replace(/\bclass="([^"]*)"/g, (m, v) => 'class="' + v.split(/\s+/).filter(Boolean).map(C).join(' ') + '"')
  .replace(/\b(id|for)="([^"]+)"/g, (m, a, v) => `${a}="zlp3-${v}"`)
  .replace(/\bhref="#([^"]+)"/g, 'href="#zlp3-$1"');
const folha = (tipo) => (D.folhas || []).find(f => f.tipo === tipo);
const modal = (tipo) => (D.modais || []).find(f => f.tipo === tipo);
const RM = matchMedia('(prefers-reduced-motion: reduce)');
const DESK = matchMedia('(min-width: 900px)');
const fmt = (x) => String(Math.round(x * 10) / 10).replace('.', ',');
/* Modal "Seu pet cabe?" sem ficha (sem medida/peso confiável no cadastro): NÃO calcula. Junta o que o cliente preencheu e manda ao WhatsApp.
   Campos, rótulos e mensagens vêm do JSON (modal.campos, aria_sp, msg0/msg1, res0/res1, why0). esp = () => rótulo da espécie escolhida (opcional). */
const semFicha = (M) => !M.ficha || M.modo === 'whatsapp';
const numCampo = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
function modalWa(M, esp) {
  const campos = M.campos.map(c => [c, I(c.id)]), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa'), res = I('fitRes'), altBox = I('fitAlt');
  return () => {
    const vals = campos.map(([c, el]) => [c, numCampo(el)]).filter(x => x[1]);
    const nome = esp && esp();
    const linhas = (nome && M.aria_sp ? [`${M.aria_sp}: ${nome}`] : []).concat(vals.map(([c, v]) => `${c.label}: ${fmt(v)} ${c.un}`));
    delete res.dataset.lv; altBox.hidden = true; altBox.innerHTML = '';
    lv.textContent = vals.length ? (M.res1 || M.res0) : M.res0;
    why.innerHTML = vals.length ? linhas.map(t => `<li>${t}</li>`).join('') : `<li>${M.why0}</li>`;
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(vals.length ? `${M.msg1}\n${linhas.join('\n')}` : M.msg0)}`;
  };
}
const ar = (s) => { const [w, h] = String(s).split('/').map(Number); return w / h; };

/* ---------- Anatomia com chamadas e linha-guia (pinos x,y em % da foto; rótulo em lx,ly) ---------- */
(() => {
  const svg = I('coSvg'); if (!svg) return;
  const an = folha('anatomia'), im = D.img[an.img], W = im.w, H0 = im.h, ns = 'http://www.w3.org/2000/svg';
  const lbl = I('coLbl'), leg = I('legend');
  an.pinos.forEach((c, i) => {
    const px = c.x / 100 * W, py = c.y / 100 * H0, ex = c.lx / 100 * W, ey = c.ly / 100 * H0;
    const kx = c.r ? Math.max(px + 40, ex - 160) : Math.min(px - 40, ex + 160);
    const pl = document.createElementNS(ns, 'polyline');
    pl.setAttribute('points', `${px},${py} ${kx},${ey} ${ex},${ey}`); pl.setAttribute('pathLength', '1');
    pl.style.transitionDelay = (i * 0.12) + 's';
    const ring = document.createElementNS(ns, 'circle'); ring.setAttribute('class', C('ring')); ring.setAttribute('cx', px); ring.setAttribute('cy', py); ring.setAttribute('r', 11);
    const dot = document.createElementNS(ns, 'circle'); dot.setAttribute('class', C('dot')); dot.setAttribute('cx', px); dot.setAttribute('cy', py); dot.setAttribute('r', 4);
    svg.append(pl, ring, dot);
    const d = document.createElement('div'); d.className = C('lbl') + (c.r ? ' ' + C('r') : '');
    d.style.left = c.lx + '%'; d.style.top = c.ly + '%'; d.style.transitionDelay = (0.7 + i * 0.12) + 's';
    d.innerHTML = `${c.t}<small>${c.s}</small>`; lbl.append(d);
    const n = document.createElement('span'); n.className = C('num'); n.textContent = i + 1; n.style.left = c.x + '%'; n.style.top = c.y + '%'; lbl.append(n);
    const li = document.createElement('li'); li.innerHTML = `<i>${i + 1}</i><span>${c.m || c.t}</span>`; leg.append(li);
  });
  const plate = I('plate');
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { plate.classList.add(C('drawn')); o.disconnect(); }
  }), { threshold: 0.35 }).observe(plate);
})();

/* ---------- Visualizador (desenho técnico e "por que importa") ---------- */
const viewer = I('viewer'), vs = I('vscroll'), vimg = I('vimg');
let lastFocus = null;
const openViewer = (src, a, alt) => {
  lastFocus = document.activeElement;
  vimg.src = src; vimg.alt = alt; vs.style.setProperty('--ar', a); vs.classList.remove(C('z')); viewer.showModal();
};
if (I('openBp')) I('openBp').onclick = () => {
  const b = I('openBp'), mob = matchMedia('(max-width:759px)').matches;
  openViewer(mob ? b.dataset.m : b.dataset.d, ar(mob ? b.dataset.arm : b.dataset.ard), b.dataset.alt);
};
if (I('openFis')) I('openFis').onclick = () => { const b = I('openFis'); openViewer(b.dataset.src, ar(b.dataset.ar), b.dataset.alt); };
I('vClose').onclick = () => viewer.close();
viewer.addEventListener('click', e => { if (e.target === viewer) viewer.close(); });
viewer.addEventListener('close', () => lastFocus && lastFocus.focus());
vimg.onclick = (e) => {
  const r = vimg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
  vs.classList.toggle(C('z'));
  if (vs.classList.contains(C('z'))) requestAnimationFrame(() => {
    vs.scrollLeft = fx * vs.scrollWidth - vs.clientWidth / 2; vs.scrollTop = fy * vs.scrollHeight - vs.clientHeight / 2;
  });
};

/* ---------- Carrossel genérico (gestos e perguntas) ---------- */
function carousel({ track, items, prev, next, count, bar, onIndex }) {
  let cur = 0;
  const n = items.length;
  const idxNow = () => {
    const max = track.scrollWidth - track.clientWidth;
    return max > 0 ? Math.round(track.scrollLeft / max * (n - 1)) : 0;
  };
  const paint = (i) => {
    cur = i;
    count.textContent = `${i + 1}/${n}`;
    bar.style.transform = `scaleX(${(i + 1) / n})`;
    prev.disabled = i === 0; next.disabled = i === n - 1;
    onIndex && onIndex(i);
  };
  const go = (i) => {
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
    paint(i);
  };
  let raf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = idxNow(); if (i !== cur) paint(i); }); }, { passive: true });
  prev.addEventListener('click', () => go(cur - 1));
  next.addEventListener('click', () => go(cur + 1));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
  });
  paint(0);
  return { go, get i() { return cur; } };
}

// Gestos: carrossel no celular, foto fixa que troca no desktop
if (I('steps')) {
  const steps = $$('.step'), gImgs = $$('.g-fig img'), nS = steps.length;
  const gN = I('gN'), gP = I('gP');
  const setStep = (i) => {
    steps.forEach((s, k) => s.classList.toggle(C('on'), k === i));
    gImgs.forEach((im, k) => im.classList.toggle(C('on'), k === i));
    gN.textContent = `Passo ${i + 1} de ${nS}`; gP.parentElement.style.setProperty('--p', (i + 1) / nS);
  };
  carousel({ track: I('steps'), items: steps, prev: I('gPrev'), next: I('gNext'),
    count: I('gCount'), bar: I('gBar'), onIndex: (i) => { if (!DESK.matches) setStep(i); } });
  const stepIO = new IntersectionObserver((es) => {
    if (!DESK.matches) return;
    es.forEach(e => { if (e.isIntersecting) setStep(steps.indexOf(e.target)); });
  }, { rootMargin: '-45% 0px -45% 0px' });
  steps.forEach(s => stepIO.observe(s));
}

// Perguntas: carrossel no celular, índice no desktop
if (I('track')) {
  const idxBtns = $$('#qIdx button');
  const qc = carousel({ track: I('track'), items: $$('.qc'), prev: I('qPrev'), next: I('qNext'),
    count: I('qCount'), bar: I('qBar'),
    onIndex: (i) => idxBtns.forEach((b, k) => b.setAttribute('aria-current', String(k === i))) });
  idxBtns.forEach((b, k) => b.addEventListener('click', () => qc.go(k)));
}

/* ---------- Cor: estado único, compartilhado por bloco de cores, comparativo e palco ---------- */
const COR = Object.fromEntries((D.cores || []).map(c => [c.k, c]));
let cor = R.querySelector('img[data-cor].z3-on')?.dataset.cor || (D.cores && D.cores[0] && D.cores[0].k);
$$('[data-sw]').forEach(g => {
  g.innerHTML = H(Object.entries(COR).map(([k, c]) =>
    `<button class="sw" type="button" role="radio" data-k="${k}" aria-label="${c.curto || c.nome}" aria-checked="${k === cor}" tabindex="${k === cor ? 0 : -1}" style="--c:${c.hex}"><i></i></button>`).join(''));
  g.addEventListener('click', e => { const b = e.target.closest(S('.sw')); if (b) setCor(b.dataset.k); });
  g.addEventListener('keydown', e => {
    const ks = Object.keys(COR), d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    const k = ks[(ks.indexOf(cor) + d + ks.length) % ks.length];
    setCor(k); g.querySelector(`[data-k="${k}"]`).focus();
  });
});
function setCor(k) {
  if (k === cor) return;
  cor = k;
  $$('.sw').forEach(b => { const on = b.dataset.k === k; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
  $$('img[data-cor]').forEach(im => { if (im.dataset.cor === k) im.loading = 'eager'; im.classList.toggle(C('on'), im.dataset.cor === k); });
  $$('[data-cor-nome]').forEach(el => { el.textContent = el.closest(S('.stage')) ? (COR[k].curto || COR[k].nome) : COR[k].nome; });
  kick();
}
if (I('pickCor')) I('pickCor').onclick = () => I('oferta').scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth' });
// shortcut: o CTA rola até a compra da PDP (topo); se a PDP ganhar âncora própria do formulário, apontar para ela
if (I('buy')) I('buy').onclick = () => window.scrollTo({ top: 0, behavior: RM.matches ? 'auto' : 'smooth' });

/* ---------- Palco: entrada com spring (damping .86, response .55 s), interrompível ---------- */
const obj = I('obj');
const SP = { k: Math.pow(2 * Math.PI / 0.55, 2), c: 4 * Math.PI * 0.86 / 0.55 };
let p = 1, v = 0, target = 1, running = false, last = 0;
const render = () => {
  const q = Math.max(0, p);
  obj.style.transform = `translate3d(0,${(1 - q) * 56}px,0) scale(${0.93 + 0.07 * q})`;
  obj.style.opacity = Math.min(1, q * 1.5);
};
const tick = (t) => {
  const dt = Math.min(0.032, (t - last) / 1000 || 0.016); last = t;
  v += (-SP.k * (p - target) - SP.c * v) * dt; p += v * dt;   // parte do valor atual: nunca salta
  render();
  if (Math.abs(p - target) < 0.0005 && Math.abs(v) < 0.0005) { p = target; v = 0; render(); running = false; return; }
  requestAnimationFrame(tick);
};
const run = () => { if (!running) { running = true; last = performance.now(); requestAnimationFrame(tick); } };
function kick() { if (RM.matches || !obj) return; v -= 0.9; run(); }   // troca de cor: leve respiro do objeto
if (obj && !RM.matches) {
  const r = obj.getBoundingClientRect();
  if (r.top > innerHeight) { p = 0; render(); }
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { target = 1; run(); o.disconnect(); }
  }), { threshold: 0.2 }).observe(obj);
}

/* ---------- Modal "Seu pet cabe?" (deslocamento · carro): peso + comprimento contra o interior de cada tamanho ---------- */
(() => {
  const M = modal('cabe'); if (!M || !I('fit')) return;
  const FICHA = M.ficha, RACAS = M.racas && M.racas.dados, ALT = M.alt || {}, NOMES = M.nomes, VL0 = (M.racas && M.racas.veredito) || {}, SEM = semFicha(M);
  const alternativa = (peso) => peso <= M.alt_regra.max ? M.alt_regra.ate : M.alt_regra.acima;
  const fit = I('fit');
  const fP = I('fPeso'), fC = I('fComp'), fA = I('fAlt');
  const altBox = I('fitAlt'), res = I('fitRes'), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa');
  const num = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
  function avalia(peso, comp, alt) {
    const ordem = { folga: 0, limite: 1, nao: 2 };
    let best = null;
    for (const [tam, m] of Object.entries(FICHA.tamanhos)) {
      let n = comp <= m.comprimento - FICHA.folgaCm ? 'folga' : comp <= m.comprimento + FICHA.limiteCm ? 'limite' : 'nao';
      const np = peso <= FICHA.pesoMax ? 'folga' : peso <= FICHA.pesoMax * (1 + FICHA.limitePeso) ? 'limite' : 'nao';
      if (ordem[np] > ordem[n]) n = np;
      let altAviso = false;
      if (alt && n === 'folga' && alt > m.altura + 4) { n = 'limite'; altAviso = true; }
      const r = { tam, m, n, np, altAviso };
      if (!best || ordem[n] < ordem[best.n]) best = r;
    }
    return best;
  }
  const waUp = SEM && modalWa(M);
  function update() {
    if (SEM) return waUp();
    const peso = num(fP), comp = num(fC), alt = num(fA);
    let msg = M.msg0;
    if (peso && comp) {
      const r = avalia(peso, comp, alt);
      res.dataset.lv = r.n;
      lv.textContent = NOMES[r.n] + (r.n !== 'nao' ? ` (tamanho ${r.tam})` : '');
      const li = [];
      li.push(`Seu pet mede ${fmt(comp)} cm; o interior do ${r.tam} tem cerca de ${fmt(r.m.comprimento)} cm.`);
      li.push(r.np === 'folga' ? `${fmt(peso)} kg está dentro do peso máximo da ficha.` : r.np === 'limite' ? `${fmt(peso)} kg passa um pouco do peso máximo da ficha.` : `${fmt(peso)} kg passa do peso máximo da ficha.`);
      if (r.altAviso) li.push(`Sentado, ele mede ${fmt(alt)} cm; o interior tem cerca de ${fmt(r.m.altura)} cm de altura. Deitado, cabe.`);
      if (r.n === 'limite') li.push('Fale com a gente antes de comprar e confirmamos.');
      if (r.n === 'nao') li.push('O espaço interno não acomoda o tamanho dele com conforto.');
      if (fonte) li.push(`Medidas típicas da tabela para ${fonte}. Meça o seu para confirmar.`);
      why.innerHTML = li.map(t => `<li>${t}</li>`).join('');
      altBox.hidden = r.n !== 'nao';
      altBox.innerHTML = r.n !== 'nao' ? '' : H('<p>Para a mesma necessidade, na loja</p>' + alternativa(peso).map(k => { const a = ALT[k];
        return `<a href="${a.href}"><span class="th" aria-hidden="true">${a.th}</span><span><b>${a.nome}</b><small>${a.spec}</small></span><svg class="ico" aria-hidden="true"><use href="#i-r"/></svg></a>`; }).join(''));
      msg = `${M.msg1}\nPeso: ${fmt(peso)} kg\nComprimento (focinho à base da cauda): ${fmt(comp)} cm\nAltura sentado: ${alt ? fmt(alt) + ' cm' : 'não medi'}\nResultado na página: ${NOMES[r.n]}${r.n !== 'nao' ? ' (tamanho ' + r.tam + ')' : ''}${fonte ? '\nRaça (médias da tabela): ' + fonte : ''}`;
    } else {
      delete res.dataset.lv; altBox.hidden = true; altBox.innerHTML = '';
      lv.textContent = M.res0;
      why.innerHTML = `<li>${M.why0}</li>`;
    }
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(msg)}`;
  }
  let fonte = null;
  [fP, fC, fA].filter(Boolean).forEach(el => el.addEventListener('input', () => { if (el !== fA) fonte = null; update(); }));
  I('fitForm').addEventListener('submit', e => e.preventDefault());
  let fitFrom = null;
  $$('[data-fit]').forEach(b => b.addEventListener('click', () => { fitFrom = b; showMain(); update(); fit.showModal(); I('fitH').focus(); }));   // foco no título: nenhum campo abre o teclado sozinho
  I('fitClose').onclick = () => fit.close();
  $$('[data-close]', fit).forEach(b => b.onclick = () => fit.close());

  /* ---------- Tabela de raças (mesma regra do modal) ---------- */
  const main = I('fitMain'), rc = I('racas'), rcList = I('rcList'), rcQ = I('rcQ'), rcEmpty = I('rcEmpty'), rcOpen = I('rcOpen');
  const tabs = rc ? [...rc.querySelectorAll('[role=tab]')] : [];
  const VL = { folga: [VL0.folga, 'i-ok'], limite: [VL0.limite, 'i-ap'], nao: [VL0.nao, 'i-x'] };
  const norm = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const mid = (a, b) => Math.round((a + b) / 2 * 10) / 10;
  let sp = tabs[0] && tabs[0].dataset.sp;
  function showMain() { if (rc) rc.hidden = true; main.hidden = false; fit.classList.remove(C('wide')); }
  function showRacas() {
    main.hidden = true; rc.hidden = false; fit.classList.add(C('wide')); fit.scrollTop = 0; renderRacas(); I('rcH').focus();
  }
  function renderRacas() {
    const q = norm(rcQ.value.trim());
    const rows = RACAS[sp].filter(r => !q || norm(r[0]).includes(q));
    rcList.innerHTML = H(rows.map(([nome, porte, p1, p2, c1, c2]) => {
      // média da faixa; se ela não cabe mas o adulto menor da faixa fica no limite, a raça entra como "no limite" e preenche com ele
      let pv = mid(p1, p2), cv = mid(c1, c2), r = avalia(pv, cv, null);
      if (r.n === 'nao' && avalia(p1, c1, null).n !== 'nao') { pv = p1; cv = c1; r = { n: 'limite' }; }
      const [vt, vi] = VL[r.n], alt = r.n === 'nao' ? alternativa(pv).map(k => ALT[k].curto || k).join(' + ') : '';
      const peso = `${fmt(p1)}–${fmt(p2)} kg`, comp = `${c1}–${c2} cm`;
      return `<li><button class="rc-row" type="button" data-nome="${nome}" data-p="${pv}" data-c="${cv}" aria-label="${nome}: porte ${porte}, ${peso}, ${comp}, ${M.racas.no_produto}: ${vt}${alt ? '. Veja a alternativa: ' + alt : ''}. Preencher o formulário">` +
        `<span class="rc-n">${nome}</span><span class="rc-m"><span>${porte[0].toUpperCase() + porte.slice(1)}</span><span>${peso}</span><span>${comp}</span></span>` +
        `<span class="rc-v" data-lv="${r.n}"><svg class="ico" aria-hidden="true"><use href="#${vi}"/></svg>${vt}</span>${alt ? `<span class="rc-alt">Veja a alternativa: <b>${alt}</b></span>` : ''}</button></li>`;
    }).join(''));
    rcEmpty.hidden = rows.length > 0;
  }
  if (rc) {
  rcOpen.addEventListener('click', showRacas);
  I('rcBack').onclick = () => { showMain(); rcOpen.focus(); };
  rcQ.addEventListener('input', renderRacas);
  const setTab = (t) => {
    sp = t.dataset.sp;
    tabs.forEach(b => { const on = b === t; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; });
    rcList.setAttribute('aria-labelledby', t.id); renderRacas();
  };
  tabs.forEach(t => t.addEventListener('click', () => setTab(t)));
  rc.querySelector('[role=tablist]').addEventListener('keydown', e => {
    const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!d) return;
    e.preventDefault(); const t = tabs[(tabs.indexOf(document.activeElement) + d + tabs.length) % tabs.length]; setTab(t); t.focus();
  });
  rcList.addEventListener('click', e => {
    const b = e.target.closest(S('.rc-row')); if (!b) return;
    fP.value = fmt(+b.dataset.p); fC.value = fmt(+b.dataset.c); fonte = b.dataset.nome;
    showMain(); update(); fit.scrollTop = 0;
    requestAnimationFrame(() => { res.scrollIntoView({ block: 'nearest', behavior: RM.matches ? 'auto' : 'smooth' }); res.focus({ preventScroll: true }); });
  });
  }
  fit.addEventListener('click', e => { if (e.target === fit) fit.close(); });
  fit.addEventListener('close', () => fitFrom && fitFrom.focus());
  // foco preso: Tab circula dentro do modal
  fit.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const f = [...fit.querySelectorAll('button,input,a[href]')].filter(x => x.offsetParent && x.tabIndex >= 0);
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  if (!SEM) window.__fit = avalia; // usado pelo teste de aceite
})();

})();
